import { render, staticRenderFns } from "./FetchError.vue?vue&type=template&id=015ba282&scoped=true&"
import script from "./FetchError.vue?vue&type=script&lang=js&"
export * from "./FetchError.vue?vue&type=script&lang=js&"
import style0 from "./FetchError.vue?vue&type=style&index=0&id=015ba282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ba282",
  null
  
)

export default component.exports